﻿import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || '',
  timeout: 20000
})

service.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

const handleApiFailure = body => {
  if (body.code === 401) {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminUser')
    router.replace('/login')
  }
  Message.error(body.message || '请求失败')
  return Promise.reject(body)
}

service.interceptors.response.use(async response => {
  if (response.config.responseType === 'blob') {
    const contentType = response.headers['content-type'] || ''
    if (!contentType.includes('application/json')) return response.data
    try {
      const body = JSON.parse(await response.data.text())
      return handleApiFailure(body)
    } catch (error) {
      Message.error('文件下载失败，请稍后重试')
      return Promise.reject(error)
    }
  }
  const body = response.data || {}
  if (body.code === 0) return body.data
  return handleApiFailure(body)
}, error => {
  Message.error('后端服务连接失败')
  return Promise.reject(error)
})

export default function request(url, data = {}, options = {}) {
  return service(Object.assign({ url, method: 'post', data }, options))
}

export const API_BASE = service.defaults.baseURL
export const downloadRequest = (url, data = {}) => request(url, data, { responseType: 'blob' })


